// 产品配置数据
// 根据 productId 或 variantId 来匹配配置
const PRODUCT_CONFIGS = {
  // 示例产品1：Custom Silhouette Pick Box (3步流程)
  'custom-headstock-lid-guitar-pick-box-personalized-wooden-pick-case': {
    steps: 3,
    description: "Your Guitar's Soul, Carved in Wood",
    detailedDescription: [
      "Every guitar tells a story.",
      "Yours deserves to be remembered.",
      "We hand-carve your guitar's unique silhouette into premium solid wood."
    ],
    engraving: {
      guideImage: 'engraving-options.jpg',
      hint: 'Choose a style (#1-#12) and enter your text below',
      maxStyles: 12
    }
  },

  // 🔴 关键修改：这里已经把英文名换成了数字 ID
  // 这样才能和 custom-add-to-cart.js 发过来的 ID 完美对接
  '44142805123165': {
    steps: 2, // ✅ 强制 2 步流程
    description: "Premium Wooden Pick Case",
    detailedDescription: [
      "A beautiful wooden pick case for your collection.",
      "Personalize it with custom engraving."
    ],
    engraving: {
      guideImage: 'engraving-standard.jpg',
      hint: 'Choose a style (#1-#30) and enter your text below',
      maxStyles: 30
    }
  },

  // 示例产品3：Deluxe Edition
  'deluxe-pick-box': {
    steps: 3,
    description: "Deluxe Guitar Pick Box with Custom Engraving",
    detailedDescription: ["The ultimate pick box."],
    engraving: {
      guideImage: 'engraving-deluxe.jpg',
      hint: 'Choose a style (#1-#20) and enter your text below',
      maxStyles: 20
    }
  }
};

// 通过 handle, productId 或 variantId 获取配置
function getProductConfig(identifier) {
  console.log("🔍 [Config Check] 正在尝试查找配置，标识符为:", identifier);

  // 1. 预处理
  if (!identifier) return null;
  if (typeof identifier === 'string') identifier = identifier.trim();
  const idStr = String(identifier);

  // 2. 直接匹配
  if (PRODUCT_CONFIGS[idStr]) {
    console.log("✅ [Config Match] 成功匹配:", idStr);
    return PRODUCT_CONFIGS[idStr];
  }

  // 3. ⚠️ 关键修改：没找到就返回 null
  // 不要在这里直接返回默认配置，否则会掩盖匹配失败的问题
  console.log("⚠️ [Config Check] 未找到配置，返回 null 以尝试下一匹配项:", idStr);
  return null; 
}

// 导出配置
if (typeof module !== 'undefined' && module.exports) {
  module.exports = { PRODUCT_CONFIGS, getProductConfig };
}
if (typeof window !== 'undefined') {
  window.getProductConfig = getProductConfig;
}